import * as client_hooks from '../../../src/hooks.client.ts';
import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45')
];

export const server_loads = [];

export const dictionary = {
		"/": [6],
		"/auth": [7],
		"/auth/sign-in": [8],
		"/balances": [9],
		"/btcfi": [10],
		"/dashboard": [11,[2]],
		"/dashboard/achievements": [12,[2]],
		"/dashboard/leaderboard": [13,[2]],
		"/dashboard/missions": [14,[2]],
		"/dashboard/rewards": [15,[2]],
		"/dashboard/wallets": [16,[2]],
		"/eudrop/claim": [17,[3]],
		"/explorer": [18],
		"/explorer/channels": [19],
		"/explorer/clients": [20],
		"/explorer/connections": [21],
		"/explorer/dust/[packet_hash]": [22],
		"/explorer/find-packet": [23],
		"/explorer/orbital": [24],
		"/explorer/packets": [25],
		"/explorer/packets/incomplete": [27],
		"/explorer/packets/[packet_hash]": [26,[4]],
		"/explorer/stakes/[packet_hash]": [28],
		"/explorer/tokens": [29],
		"/explorer/transfers": [30],
		"/explorer/transfers/[packet_hash]": [31,[5]],
		"/explorer/unstakes/[packet_hash]": [32],
		"/explorer/withdrawals/[packet_hash]": [33],
		"/faucet": [34],
		"/health": [35],
		"/liquid-staking": [36],
		"/nodes": [37],
		"/privacy-policy": [38],
		"/stake": [39],
		"/transfers": [44],
		"/transfer": [40],
		"/transfer/multisig": [41],
		"/transfer/native": [42],
		"/transfer/ts-packets": [43],
		"/yaps": [45]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';